import {action, makeObservable, observable} from "mobx";
import StringUtil from "utils/StringUtil";

import IValidationRule, {ValidationRuleNames, ValidationRules} from "../rules/ValidationRule";
import ValidationRuleFunction from "../rules/ValidationRuleFunction";
import ValidationUtil from "../util/ValidationUtil";

export default class ValueChecker {
    private _value: any;
    private _rules: IValidationRule[];

    checked: boolean | undefined;
    message: string | undefined;
    inform: string | undefined;
    valid: boolean = false;

    public constructor(rules?: (ValidationRuleNames | ((value: any) => string | undefined) | null)[] | null) {
        makeObservable(this, {
            checked: observable,
            message: observable,
            inform: observable,
            valid: observable,
            setInform: action,
            setValue: action,
            setChecked: action,
            setMessage: action,
            checkValid: action
        })

        if (!rules || rules.length === 0) {
            this._rules = [];
            this.valid = true;
        } else {
            this._rules = rules
                .filter((rule) => rule != null)
                .map((rule: ValidationRuleNames | ((value: any) => string | undefined) | null) => {
                    if (typeof rule === "string") {
                        if (rule.startsWith("function")) {
                            const fArgs = rule.substring(rule.indexOf('(') + 1, rule.indexOf(')'))
                            const fBody = rule.substring(rule.indexOf('{') + 1, rule.lastIndexOf('}'))
                            const func = new Function(fArgs, fBody);
                            return new ValidationRuleFunction(func);
                        } else {
                            // @ts-ignore
                            if (rule === "undefined") {
                                return undefined;
                            } else {
                                return Object.create(ValidationRules[rule]);
                            }
                        }
                    }

                    if (typeof rule === "function") {
                        return new ValidationRuleFunction(rule);
                    }

                    return undefined;
                });
        }
    }

    public addRule(rule: IValidationRule): void {
        this._rules.push(rule);
    }

    public setValue(_value: any): void {
        if (typeof _value === "function") {
            this._value = _value();
        } else {
            this._value = _value;
        }

        if (this.checked == null && ValidationUtil.isNotEmpty(this._value)) {
            this.setChecked(true);
        }

        if (this.checked === true) {
            this.checkValid();
        }

        this.resetInform();
    }

    public setChecked(checked: boolean | undefined): void {
        this.checked = checked;
    }

    public setMessage(message: string | undefined): void {
        this.message = message;
    }

    public setInform(inform: string | undefined): void {
        this.inform = inform;
    }

    public checkValid() {
        this.setMessage(
            (() => {
                let message: string | undefined;

                for (let i = 0; i < this._rules.length; i++) {
                    if(this._rules[i]) {
                        this.valid = this._rules[i].check(this._value);

                        if (StringUtil.isNotEmpty(this._rules[i].message)) {
                            message = this._rules[i].message;
                        }

                        if (!this.valid) {
                            break;
                        }
                    }
                }

                return message;
            })()
        );

        this.setChecked(true);

        return this.valid;
    }

    private resetInform(): void {
        this.setInform(
            (() => {
                for (let i = 0; i < this._rules.length; i++) {
                    if(this._rules[i]) {
                        this._rules[i].check(this._value);

                        if (StringUtil.isNotEmpty(this._rules[i].inform)) {
                            return this._rules[i].inform;
                        }
                    }
                }
            })()
        );
    }
}
